<template>
  <slot></slot>
</template>

<script>
export default {};
</script>
